import upperFirst from 'lodash/upperFirst';

export interface ApiError {
  http_status: number;
  message: string;
  object: string;
  type: string;
  uid?: string;
}

export const formatErrorMessage = (message: string) => {
  const normalizedMessage = upperFirst(message.trim());

  return /[.!?]$/.test(normalizedMessage) ? normalizedMessage : `${normalizedMessage}.`;
};

export function isApiError(item: unknown): item is ApiError {
  if (!item || typeof item !== 'object') {
    return false;
  }

  return !!(item as ApiError).http_status;
}
